import { Icons } from '@/utils/Icons';
import { useState } from 'react';
import MyBets from './MyBets';
import { useAppSelector } from '@/hooks';
import { isGuestUser } from '@/utils';
import Betslip from './Betslip';

const BettingContainer = () => {
  const isGuest = isGuestUser();
  const { liveTvUrl } = useAppSelector((state) => state.media);
  const [openTv, setOpenTv] = useState<boolean>(false);
  return (
    <div className="sticky top-0 max-lg:hidden text-black w-[350px] 2xl:w-[450px] 3xl:w-[550px] pl-[2px] min-h-[calc(100vh-135px)] max-h-[calc(100vh-135px)] overflow-x-hidden overflow-y-auto ml-0">
      <div className="text-sm  overflow-y-auto">
        {/* Live Match title */}
        {!isGuest && (
          <div
            onClick={() => setOpenTv((prev) => !prev)}
            className="cursor-pointer bg-white  flex gap-1 items-center font-semibold px-2 py-1 border-t border-gray-700 "
          >
            Live Match <Icons.Tv />
          </div>
        )}

        {openTv && liveTvUrl && (
          <div className="w-full aspect-video overflow-hidden">
            {' '}
            <iframe scrolling="no" className="w-full h-full" src={liveTvUrl}></iframe>
          </div>
        )}
        {/* Place Bet title */}
        <Betslip />
        {/* My Bet Header */}
        {!isGuest && (
          <>
            <MyBets />
          </>
        )}
      </div>
    </div>
  );
};

export default BettingContainer;
